import { render, staticRenderFns } from "./propertyModel.vue?vue&type=template&id=4c15a223&scoped=true&"
import script from "./propertyModel.vue?vue&type=script&lang=js&"
export * from "./propertyModel.vue?vue&type=script&lang=js&"
import style0 from "./propertyModel.vue?vue&type=style&index=0&id=4c15a223&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15a223",
  null
  
)

export default component.exports